import { c as _c } from "react/compiler-runtime";
import type { AgentBuilderHistoryItem } from '@onefootprint/request-types/dashboard';
import type { ViewMode } from '../../store/types';
import HistoryButton from './history-button';
type UndoRedoProps = {
  previous?: AgentBuilderHistoryItem;
  next?: AgentBuilderHistoryItem;
  onUndo: () => void;
  onRedo: () => void;
  disabled: boolean;
  viewMode: ViewMode;
};
const UndoRedo = t0 => {
  const $ = _c(12);
  const {
    previous,
    next,
    onUndo,
    onRedo,
    disabled,
    viewMode
  } = t0;
  if (!previous && !next) {
    return null;
  }
  if (viewMode === "credentials") {
    return null;
  }
  let t1;
  if ($[0] !== disabled || $[1] !== onUndo || $[2] !== previous) {
    t1 = <HistoryButton kind="undo" item={previous} disabled={disabled} onClick={onUndo} />;
    $[0] = disabled;
    $[1] = onUndo;
    $[2] = previous;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== disabled || $[5] !== next || $[6] !== onRedo) {
    t2 = <HistoryButton kind="redo" item={next} disabled={disabled} onClick={onRedo} />;
    $[4] = disabled;
    $[5] = next;
    $[6] = onRedo;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span aria-hidden={true} className="ml-1 h-4 w-px bg-(--border-color-tertiary)" />;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t1 || $[10] !== t2) {
    t4 = <div className="flex shrink-0 items-center gap-1">{t1}{t2}{t3}</div>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};
export default UndoRedo;